import { Container } from './container.js';
import { CallToAction } from './item.js';

export enum PageTemplates {
  modular = 'elevate-modular-ui',
  collection = 'elevate-collection',
  myContent = 'elevate-my-content',
  search = 'elevate-search',
  signin = 'elevate-sign-in',
  signup = 'elevate-sign-up',
  info = 'elevate-info',
  player = 'elevate-player',
  category = 'elevate-category',
  movieDetail = 'elevate-movie-detail',
  home = 'home',
  viewAll = 'view-all',
}

interface PageLayout {
  id: string;
  title?: string;
  template: PageTemplates;
  containerIds?: string[];
  containers?: Container[];
  containersIds?: string[];
  /** Preserved callToActions from the hero container for detail pages (hero is stripped from containers). */
  heroCallToActions?: CallToAction[];
}
export type { PageLayout };
